import { EmptyState } from '@dealstack/frontend/shared/components/EmptyState/EmptyState';
import { useTranslationValuations } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

export const NewValuationPlaceholder = () => {
	const tValuations = useTranslationValuations();
	return (
		<EmptyState
			icon="es-person-boxes"
			title={tValuations('new_valuation_placeholder_title')}
			description={tValuations('new_valuation_placeholder_message')}
		/>
	);
};
